// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Conditions-module__font-s-10___w1iom {
  font-size: 10px !important;
}

.Conditions-module__font-s-12___sx6s5 {
  font-size: 12px !important;
}

.Conditions-module__font-s-13___pMrQb {
  font-size: 13px !important;
}

.Conditions-module__font-s-14___pyJZu {
  font-size: 14px !important;
}

.Conditions-module__font-s-15___maJv5 {
  font-size: 15px !important;
}

.Conditions-module__font-s-16____qXLO {
  font-size: 16px !important;
}

.Conditions-module__font-s-18___Pi1yr {
  font-size: 18px !important;
}

.Conditions-module__font-s-20___hFeuu {
  font-size: 20px !important;
}

.Conditions-module__font-s-22___bTK6f {
  font-size: 22px !important;
}

.Conditions-module__font-s-28___oWxxd {
  font-size: 28px !important;
}

.Conditions-module__font-w-400____TtJ9 {
  font-weight: 400 !important;
}

.Conditions-module__font-w-500___pCXaG {
  font-weight: 500 !important;
}

.Conditions-module__font-w-600___zRBFx {
  font-weight: 600 !important;
}

.Conditions-module__font-w-700___JkFV2 {
  font-weight: 700 !important;
}

.Conditions-module__p-5___uiRAZ {
  padding: 5px !important;
}

.Conditions-module__p-12___LvPhR {
  padding: 12px !important;
}

.Conditions-module__p-16___MG1Sr {
  padding: 16px !important;
}

.Conditions-module__p-30___XdcQF {
  padding: 30px !important;
}

.Conditions-module__p-b-0___vzuB2 {
  padding-bottom: 0 !important;
}

.Conditions-module__p-b-5___vNFHL {
  padding-bottom: 5px !important;
}

.Conditions-module__p-b-10___PoL_v {
  padding-bottom: 10px !important;
}

.Conditions-module__p-b-12___Ln9t1 {
  padding-bottom: 12px !important;
}

.Conditions-module__p-b-16___d3GIa {
  padding-bottom: 16px !important;
}

.Conditions-module__p-b-18____kpBx {
  padding-bottom: 18px !important;
}

.Conditions-module__p-b-20___HuIDH {
  padding-bottom: 20px !important;
}

.Conditions-module__p-b-25___EOMI4 {
  padding-bottom: 25px !important;
}

.Conditions-module__p-b-30___b1ijv {
  padding-bottom: 30px !important;
}

.Conditions-module__p-b-50___ZuaGJ {
  padding-bottom: 50px !important;
}

.Conditions-module__p-t-0___PUWfO {
  padding-top: 0 !important;
}

.Conditions-module__p-t-12___Oe_7G {
  padding-top: 12px !important;
}

.Conditions-module__p-t-16___u3tAU {
  padding-top: 16px !important;
}

.Conditions-module__p-t-18___HB0Zo {
  padding-top: 18px !important;
}

.Conditions-module__p-t-20___yYlLo {
  padding-top: 20px !important;
}

.Conditions-module__p-t-30___G1vPV {
  padding-top: 30px !important;
}

.Conditions-module__p-t-40___Hd8qM {
  padding-top: 40px !important;
}

.Conditions-module__p-t-50___gcXHI {
  padding-top: 50px !important;
}

.Conditions-module__p-l-20___EVZi5 {
  padding-left: 20px !important;
}

.Conditions-module__p-l-30___d3nyP {
  padding-left: 30px !important;
}

.Conditions-module__p-l-40___MP8Oh {
  padding-left: 40px !important;
}

.Conditions-module__p-r-16___cXSWm {
  padding-right: 16px !important;
}

.Conditions-module__p-r-20___tDr3k {
  padding-right: 20px !important;
}

.Conditions-module__p-r-30___nKYBo {
  padding-right: 30px !important;
}

.Conditions-module__p-r-50___JmaFk {
  padding-right: 50px !important;
}

.Conditions-module__p-r-60___a5YdK {
  padding-right: 60px !important;
}

.Conditions-module__m-b-1___ZRNNa {
  margin-bottom: 1px !important;
}

.Conditions-module__m-b-2___kdvK9 {
  margin-bottom: 2px !important;
}

.Conditions-module__m-b-6___hwLpB {
  margin-bottom: 6px !important;
}

.Conditions-module__m-b-8___UpG6g {
  margin-bottom: 8px !important;
}

.Conditions-module__m-b-10___gDVz9 {
  margin-bottom: 10px !important;
}

.Conditions-module__m-b-14___Z6Ro8 {
  margin-bottom: 14px !important;
}

.Conditions-module__m-b-16___hsy5h {
  margin-bottom: 16px !important;
}

.Conditions-module__m-b-20___AEJ4c {
  margin-bottom: 20px !important;
}

.Conditions-module__m-b-22___CCqoi {
  margin-bottom: 22px !important;
}

.Conditions-module__m-b-24___A89HX {
  margin-bottom: 24px !important;
}

.Conditions-module__m-b-30___mjdWC {
  margin-bottom: 30px !important;
}

.Conditions-module__m-b-32___bj7DP {
  margin-bottom: 32px !important;
}

.Conditions-module__m-b-40___Q5eCQ {
  margin-bottom: 40px !important;
}

.Conditions-module__m-t-2___dPdkJ {
  margin-top: 2px !important;
}

.Conditions-module__m-t-3___c45DP {
  margin-top: 3px !important;
}

.Conditions-module__m-t-4___M7_vT {
  margin-top: 4px !important;
}

.Conditions-module__m-t-5___bPUy4 {
  margin-top: 5px !important;
}

.Conditions-module__m-t-8___QGPfu {
  margin-top: 8px !important;
}

.Conditions-module__m-t-10____LAA7 {
  margin-top: 10px !important;
}

.Conditions-module__m-t-15___ne2FB {
  margin-top: 15px !important;
}

.Conditions-module__m-t-16___e_NIB {
  margin-top: 16px !important;
}

.Conditions-module__m-t-20___TAw41 {
  margin-top: 20px !important;
}

.Conditions-module__m-t-22___W0beG {
  margin-top: 22px !important;
}

.Conditions-module__m-t-30___k9Yib {
  margin-top: 30px !important;
}

.Conditions-module__m-t-32___vAR39 {
  margin-top: 32px !important;
}

.Conditions-module__m-l-auto____LHfb {
  margin-left: auto !important;
}

.Conditions-module__m-l-4___MEojE {
  margin-left: 4px !important;
}

.Conditions-module__m-l-5___sqBgg {
  margin-left: 5px !important;
}

.Conditions-module__m-l-6___TyodX {
  margin-left: 6px !important;
}

.Conditions-module__m-l-8___sSlSm {
  margin-left: 8px !important;
}

.Conditions-module__m-l-10___BMZiM {
  margin-left: 10px !important;
}

.Conditions-module__m-l-16___ZuN36 {
  margin-left: 16px !important;
}

.Conditions-module__m-l-20___VcBSh {
  margin-left: 20px !important;
}

.Conditions-module__m-l-24___Eei50 {
  margin-left: 24px !important;
}

.Conditions-module__m-l-30___RP_cI {
  margin-left: 30px !important;
}

.Conditions-module__m-l-35___KjbC5 {
  margin-left: 35px !important;
}

.Conditions-module__m-l-40___SsAKv {
  margin-left: 40px !important;
}

.Conditions-module__m-r-8___ic9ba {
  margin-right: 8px !important;
}

.Conditions-module__m-r-10___JMvHb {
  margin-right: 10px !important;
}

.Conditions-module__m-r-16___nSPAb {
  margin-right: 16px !important;
}

.Conditions-module__m-r-20___wOSK2 {
  margin-right: 20px !important;
}

.Conditions-module__m-r-24___OLb3G {
  margin-right: 24px !important;
}

.Conditions-module__m-r-30___eKJh4 {
  margin-right: 30px !important;
}

.Conditions-module__m-r-40___KqdSh {
  margin-right: 40px !important;
}

.Conditions-module__border-r-3___NfUCb {
  border-radius: 3px !important;
}

.Conditions-module__border-r-4___Bwd1F {
  border-radius: 4px !important;
}

.Conditions-module__border-r-6___W65Uz {
  border-radius: 6px !important;
}

.Conditions-module__border-r-10___kPy48 {
  border-radius: 10px !important;
}

.Conditions-module__border-r-12___DwKPW {
  border-radius: 12px !important;
}

.Conditions-module__border-r-16___hfTu7 {
  border-radius: 16px !important;
}

.Conditions-module__border-r-50___pRjLZ {
  border-radius: 50% !important;
}

.Conditions-module__primary-border___yuap0 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Conditions-module__primary-border-b___Tdz0r {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Conditions-module__primary-border-t___LiUlm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Conditions-module__primary-border-l___sJECd {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Conditions-module__primary-border-r___Y07WA {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Conditions-module__secondary-border___CwrYn {
  border: 1px solid #637768;
}

.Conditions-module__secondary-border-b___C8KvP {
  border-bottom: 1px solid #637768;
}

.Conditions-module__secondary-border-t___X50gI {
  border-top: 1px solid #637768;
}

.Conditions-module__secondary-border-l___EfqCM {
  border-left: 1px solid #637768;
}

.Conditions-module__secondary-border-r___j5oGx {
  border-right: 1px solid #637768;
}

.Conditions-module__gap-0___w8QYx {
  gap: 0 !important;
}

.Conditions-module__gap-2___PwyAS {
  gap: 2px !important;
}

.Conditions-module__gap-4___Ia6WK {
  gap: 4px !important;
}

.Conditions-module__gap-5___P37Mj {
  gap: 5px !important;
}

.Conditions-module__gap-6___pQit9 {
  gap: 6px !important;
}

.Conditions-module__gap-8___kQpyD {
  gap: 8px !important;
}

.Conditions-module__gap-10___bDX1b {
  gap: 10px !important;
}

.Conditions-module__gap-12___yAL5F {
  gap: 12px !important;
}

.Conditions-module__gap-14___sGH_w {
  gap: 14px !important;
}

.Conditions-module__gap-16___ioOuq {
  gap: 16px !important;
}

.Conditions-module__gap-18___iXxC9 {
  gap: 18px !important;
}

.Conditions-module__gap-20___QW5w5 {
  gap: 20px !important;
}

.Conditions-module__gap-24___e2Vom {
  gap: 24px !important;
}

.Conditions-module__gap-26___i8KZY {
  gap: 26px !important;
}

.Conditions-module__gap-30___xzHhZ {
  gap: 30px !important;
}

.Conditions-module__gap-32___bvggG {
  gap: 32px !important;
}

.Conditions-module__gap-40___kjFyY {
  gap: 40px !important;
}

.Conditions-module__gap-50___n8X5o {
  gap: 50px !important;
}

.Conditions-module__flex-1___AUcB8 {
  flex: 1;
}

.Conditions-module__flex-none___Zpbiy {
  flex: none !important;
}

.Conditions-module__flex-column___SatTo {
  display: flex;
  flex-direction: column !important;
}

.Conditions-module__flex-row___uh_DK {
  display: flex;
  flex-direction: row !important;
}

.Conditions-module__vertically-centered___DnB8o {
  display: flex;
  align-items: center !important;
}

.Conditions-module__horizontally-centered___GrAe7 {
  display: flex;
  justify-content: center !important;
}

.Conditions-module__horizontally-end___Tf217 {
  display: flex;
  justify-content: end !important;
}

.Conditions-module__vertically-start___DhVrw {
  display: flex;
  align-items: start !important;
}

.Conditions-module__space-between___Ds0k4 {
  display: flex;
  justify-content: space-between !important;
}

.Conditions-module__flex-wrap___P5KXg {
  flex-wrap: wrap !important;
}

.Conditions-module__height-100___Q7jxk {
  height: 100%;
}

.Conditions-module__width-50___FUDVe {
  width: 50% !important;
}

.Conditions-module__width-100___CUok5 {
  width: 100%;
}

.Conditions-module__cursor-pointer___dUq85 {
  cursor: pointer;
}

.Conditions-module__cursor-not-allowed___tU3RR {
  cursor: not-allowed !important;
}

.Conditions-module__absolute-centered___cGkXk {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Conditions-module__absolute___jX9Qx {
  position: absolute;
}

.Conditions-module__relative___utqPI {
  position: relative;
}

.Conditions-module__fixed___D1TwC {
  position: fixed;
}

.Conditions-module__visible___M1KFg {
  opacity: 1;
}

.Conditions-module__invisible___O9Mx6 {
  opacity: 0;
}

.Conditions-module__col-90___Wog1a {
  width: 90% !important;
}

.Conditions-module__col-auto___guv94 {
  width: auto !important;
}

.Conditions-module__medical-tabs___gY10Q {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Conditions-module__medical-table-new___F_SpC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Conditions-module__medical-table-new___F_SpC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Conditions-module__medical-table-new___F_SpC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Conditions-module__medical-table-new___F_SpC::-webkit-scrollbar-track {
  display: none;
}
.Conditions-module__medical-table-new___F_SpC.Conditions-module__no-pagination___HexJw {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Conditions-module__medical-table-new___F_SpC.Conditions-module__no-pagination___HexJw:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Conditions-module__medical-table-new___F_SpC.Conditions-module__no-pagination___HexJw::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Conditions-module__medical-table-new___F_SpC.Conditions-module__no-pagination___HexJw::-webkit-scrollbar-track {
  display: none;
}

.Conditions-module__medical-table-empty___Vl0ub {
  padding: 14px 40px !important;
}

.Conditions-module__icon-btn___K5Ke5 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Conditions-module__search-icon___o9Izq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Conditions-module__disable-select___x51so {
  user-select: none;
}

.Conditions-module__break-word___rDQm_ {
  word-break: break-word;
}

.Conditions-module__popup-clear-btn___PM3Kr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Conditions-module__scroll-m-b-20___MBcLt {
  scroll-margin-bottom: 20px;
}

.Conditions-module__container___qC6U1 {
  color: #375844;
  margin-bottom: -6px;
}
.Conditions-module__container___qC6U1 .Conditions-module__grid___E73B_ {
  display: grid;
  column-gap: 30px;
  row-gap: 20px;
  grid-template-columns: 0.2fr 1fr;
}
.Conditions-module__container___qC6U1 .Conditions-module__placeholder___BO9Ji {
  color: #637768;
  font-style: italic;
}
.Conditions-module__container___qC6U1 .Conditions-module__toggleButton___d16qP {
  transition: transform 0.3s ease;
}
.Conditions-module__container___qC6U1 .Conditions-module__collapsed___a3PqH {
  transform: rotate(180deg);
}
.Conditions-module__container___qC6U1 .Conditions-module__expanded___k5uz1 {
  transform: rotate(0deg);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/ConditionsModule/Conditions.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,kBAAA;AA6pBJ;AA1pBE;EACE,+BAAA;AA4pBJ;AAzpBE;EACE,yBAAA;AA2pBJ;AAxpBE;EACE,uBAAA;AA0pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n\n  .grid {\n    display: grid;\n    column-gap: 30px;\n    row-gap: 20px;\n    grid-template-columns: 0.2fr 1fr;\n  }\n\n  .placeholder {\n    color: get-color(greenNew, medium-dark);\n    font-style: italic;\n  }\n\n  .toggleButton {\n    transition: transform 0.3s ease;\n  }\n\n  .collapsed {\n    transform: rotate(180deg); \n  }\n\n  .expanded {\n    transform: rotate(0deg);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Conditions-module__font-s-10___w1iom`,
	"fontS12": `Conditions-module__font-s-12___sx6s5`,
	"fontS13": `Conditions-module__font-s-13___pMrQb`,
	"fontS14": `Conditions-module__font-s-14___pyJZu`,
	"fontS15": `Conditions-module__font-s-15___maJv5`,
	"fontS16": `Conditions-module__font-s-16____qXLO`,
	"fontS18": `Conditions-module__font-s-18___Pi1yr`,
	"fontS20": `Conditions-module__font-s-20___hFeuu`,
	"fontS22": `Conditions-module__font-s-22___bTK6f`,
	"fontS28": `Conditions-module__font-s-28___oWxxd`,
	"fontW400": `Conditions-module__font-w-400____TtJ9`,
	"fontW500": `Conditions-module__font-w-500___pCXaG`,
	"fontW600": `Conditions-module__font-w-600___zRBFx`,
	"fontW700": `Conditions-module__font-w-700___JkFV2`,
	"p5": `Conditions-module__p-5___uiRAZ`,
	"p12": `Conditions-module__p-12___LvPhR`,
	"p16": `Conditions-module__p-16___MG1Sr`,
	"p30": `Conditions-module__p-30___XdcQF`,
	"pB0": `Conditions-module__p-b-0___vzuB2`,
	"pB5": `Conditions-module__p-b-5___vNFHL`,
	"pB10": `Conditions-module__p-b-10___PoL_v`,
	"pB12": `Conditions-module__p-b-12___Ln9t1`,
	"pB16": `Conditions-module__p-b-16___d3GIa`,
	"pB18": `Conditions-module__p-b-18____kpBx`,
	"pB20": `Conditions-module__p-b-20___HuIDH`,
	"pB25": `Conditions-module__p-b-25___EOMI4`,
	"pB30": `Conditions-module__p-b-30___b1ijv`,
	"pB50": `Conditions-module__p-b-50___ZuaGJ`,
	"pT0": `Conditions-module__p-t-0___PUWfO`,
	"pT12": `Conditions-module__p-t-12___Oe_7G`,
	"pT16": `Conditions-module__p-t-16___u3tAU`,
	"pT18": `Conditions-module__p-t-18___HB0Zo`,
	"pT20": `Conditions-module__p-t-20___yYlLo`,
	"pT30": `Conditions-module__p-t-30___G1vPV`,
	"pT40": `Conditions-module__p-t-40___Hd8qM`,
	"pT50": `Conditions-module__p-t-50___gcXHI`,
	"pL20": `Conditions-module__p-l-20___EVZi5`,
	"pL30": `Conditions-module__p-l-30___d3nyP`,
	"pL40": `Conditions-module__p-l-40___MP8Oh`,
	"pR16": `Conditions-module__p-r-16___cXSWm`,
	"pR20": `Conditions-module__p-r-20___tDr3k`,
	"pR30": `Conditions-module__p-r-30___nKYBo`,
	"pR50": `Conditions-module__p-r-50___JmaFk`,
	"pR60": `Conditions-module__p-r-60___a5YdK`,
	"mB1": `Conditions-module__m-b-1___ZRNNa`,
	"mB2": `Conditions-module__m-b-2___kdvK9`,
	"mB6": `Conditions-module__m-b-6___hwLpB`,
	"mB8": `Conditions-module__m-b-8___UpG6g`,
	"mB10": `Conditions-module__m-b-10___gDVz9`,
	"mB14": `Conditions-module__m-b-14___Z6Ro8`,
	"mB16": `Conditions-module__m-b-16___hsy5h`,
	"mB20": `Conditions-module__m-b-20___AEJ4c`,
	"mB22": `Conditions-module__m-b-22___CCqoi`,
	"mB24": `Conditions-module__m-b-24___A89HX`,
	"mB30": `Conditions-module__m-b-30___mjdWC`,
	"mB32": `Conditions-module__m-b-32___bj7DP`,
	"mB40": `Conditions-module__m-b-40___Q5eCQ`,
	"mT2": `Conditions-module__m-t-2___dPdkJ`,
	"mT3": `Conditions-module__m-t-3___c45DP`,
	"mT4": `Conditions-module__m-t-4___M7_vT`,
	"mT5": `Conditions-module__m-t-5___bPUy4`,
	"mT8": `Conditions-module__m-t-8___QGPfu`,
	"mT10": `Conditions-module__m-t-10____LAA7`,
	"mT15": `Conditions-module__m-t-15___ne2FB`,
	"mT16": `Conditions-module__m-t-16___e_NIB`,
	"mT20": `Conditions-module__m-t-20___TAw41`,
	"mT22": `Conditions-module__m-t-22___W0beG`,
	"mT30": `Conditions-module__m-t-30___k9Yib`,
	"mT32": `Conditions-module__m-t-32___vAR39`,
	"mLAuto": `Conditions-module__m-l-auto____LHfb`,
	"mL4": `Conditions-module__m-l-4___MEojE`,
	"mL5": `Conditions-module__m-l-5___sqBgg`,
	"mL6": `Conditions-module__m-l-6___TyodX`,
	"mL8": `Conditions-module__m-l-8___sSlSm`,
	"mL10": `Conditions-module__m-l-10___BMZiM`,
	"mL16": `Conditions-module__m-l-16___ZuN36`,
	"mL20": `Conditions-module__m-l-20___VcBSh`,
	"mL24": `Conditions-module__m-l-24___Eei50`,
	"mL30": `Conditions-module__m-l-30___RP_cI`,
	"mL35": `Conditions-module__m-l-35___KjbC5`,
	"mL40": `Conditions-module__m-l-40___SsAKv`,
	"mR8": `Conditions-module__m-r-8___ic9ba`,
	"mR10": `Conditions-module__m-r-10___JMvHb`,
	"mR16": `Conditions-module__m-r-16___nSPAb`,
	"mR20": `Conditions-module__m-r-20___wOSK2`,
	"mR24": `Conditions-module__m-r-24___OLb3G`,
	"mR30": `Conditions-module__m-r-30___eKJh4`,
	"mR40": `Conditions-module__m-r-40___KqdSh`,
	"borderR3": `Conditions-module__border-r-3___NfUCb`,
	"borderR4": `Conditions-module__border-r-4___Bwd1F`,
	"borderR6": `Conditions-module__border-r-6___W65Uz`,
	"borderR10": `Conditions-module__border-r-10___kPy48`,
	"borderR12": `Conditions-module__border-r-12___DwKPW`,
	"borderR16": `Conditions-module__border-r-16___hfTu7`,
	"borderR50": `Conditions-module__border-r-50___pRjLZ`,
	"primaryBorder": `Conditions-module__primary-border___yuap0`,
	"primaryBorderB": `Conditions-module__primary-border-b___Tdz0r`,
	"primaryBorderT": `Conditions-module__primary-border-t___LiUlm`,
	"primaryBorderL": `Conditions-module__primary-border-l___sJECd`,
	"primaryBorderR": `Conditions-module__primary-border-r___Y07WA`,
	"secondaryBorder": `Conditions-module__secondary-border___CwrYn`,
	"secondaryBorderB": `Conditions-module__secondary-border-b___C8KvP`,
	"secondaryBorderT": `Conditions-module__secondary-border-t___X50gI`,
	"secondaryBorderL": `Conditions-module__secondary-border-l___EfqCM`,
	"secondaryBorderR": `Conditions-module__secondary-border-r___j5oGx`,
	"gap0": `Conditions-module__gap-0___w8QYx`,
	"gap2": `Conditions-module__gap-2___PwyAS`,
	"gap4": `Conditions-module__gap-4___Ia6WK`,
	"gap5": `Conditions-module__gap-5___P37Mj`,
	"gap6": `Conditions-module__gap-6___pQit9`,
	"gap8": `Conditions-module__gap-8___kQpyD`,
	"gap10": `Conditions-module__gap-10___bDX1b`,
	"gap12": `Conditions-module__gap-12___yAL5F`,
	"gap14": `Conditions-module__gap-14___sGH_w`,
	"gap16": `Conditions-module__gap-16___ioOuq`,
	"gap18": `Conditions-module__gap-18___iXxC9`,
	"gap20": `Conditions-module__gap-20___QW5w5`,
	"gap24": `Conditions-module__gap-24___e2Vom`,
	"gap26": `Conditions-module__gap-26___i8KZY`,
	"gap30": `Conditions-module__gap-30___xzHhZ`,
	"gap32": `Conditions-module__gap-32___bvggG`,
	"gap40": `Conditions-module__gap-40___kjFyY`,
	"gap50": `Conditions-module__gap-50___n8X5o`,
	"flex1": `Conditions-module__flex-1___AUcB8`,
	"flexNone": `Conditions-module__flex-none___Zpbiy`,
	"flexColumn": `Conditions-module__flex-column___SatTo`,
	"flexRow": `Conditions-module__flex-row___uh_DK`,
	"verticallyCentered": `Conditions-module__vertically-centered___DnB8o`,
	"horizontallyCentered": `Conditions-module__horizontally-centered___GrAe7`,
	"horizontallyEnd": `Conditions-module__horizontally-end___Tf217`,
	"verticallyStart": `Conditions-module__vertically-start___DhVrw`,
	"spaceBetween": `Conditions-module__space-between___Ds0k4`,
	"flexWrap": `Conditions-module__flex-wrap___P5KXg`,
	"height100": `Conditions-module__height-100___Q7jxk`,
	"width50": `Conditions-module__width-50___FUDVe`,
	"width100": `Conditions-module__width-100___CUok5`,
	"cursorPointer": `Conditions-module__cursor-pointer___dUq85`,
	"cursorNotAllowed": `Conditions-module__cursor-not-allowed___tU3RR`,
	"absoluteCentered": `Conditions-module__absolute-centered___cGkXk`,
	"absolute": `Conditions-module__absolute___jX9Qx`,
	"relative": `Conditions-module__relative___utqPI`,
	"fixed": `Conditions-module__fixed___D1TwC`,
	"visible": `Conditions-module__visible___M1KFg`,
	"invisible": `Conditions-module__invisible___O9Mx6`,
	"col90": `Conditions-module__col-90___Wog1a`,
	"colAuto": `Conditions-module__col-auto___guv94`,
	"medicalTabs": `Conditions-module__medical-tabs___gY10Q`,
	"medicalTableNew": `Conditions-module__medical-table-new___F_SpC`,
	"noPagination": `Conditions-module__no-pagination___HexJw`,
	"medicalTableEmpty": `Conditions-module__medical-table-empty___Vl0ub`,
	"iconBtn": `Conditions-module__icon-btn___K5Ke5`,
	"searchIcon": `Conditions-module__search-icon___o9Izq`,
	"disableSelect": `Conditions-module__disable-select___x51so`,
	"breakWord": `Conditions-module__break-word___rDQm_`,
	"popupClearBtn": `Conditions-module__popup-clear-btn___PM3Kr`,
	"scrollMB20": `Conditions-module__scroll-m-b-20___MBcLt`,
	"container": `Conditions-module__container___qC6U1`,
	"grid": `Conditions-module__grid___E73B_`,
	"placeholder": `Conditions-module__placeholder___BO9Ji`,
	"toggleButton": `Conditions-module__toggleButton___d16qP`,
	"collapsed": `Conditions-module__collapsed___a3PqH`,
	"expanded": `Conditions-module__expanded___k5uz1`
};
module.exports = ___CSS_LOADER_EXPORT___;
